import React from "react";
import MultiLocationOverviewModule from "./multiLocationOverview";
import {Provider} from "react-redux";
import {createReduxStore} from "./redux/store";

class MultiLocationOverview extends React.Component {
  render() {
    return (
      <Provider store={createReduxStore("multiLocationOverview")}>
        <MultiLocationOverviewModule userParams={this.props}/>
      </Provider>
    );
  }
}

export default MultiLocationOverview;
